/** Talen die de app aanbiedt. Code is de BCP-47 tag die de spraakherkenning wil. */

export interface Language {
  code: string;
  /** Engelse naam. Gaat zo naar het vertaalmodel. */
  name: string;
  /** Nederlandse naam. Voor het beheerscherm, dat Nederlands is. */
  label: string;
  /**
   * De naam van de taal IN DIE TAAL ZELF.
   *
   * Dit is wat een gast te zien krijgt. Een Duitser die "Duits" leest, moet
   * eerst raden; "Deutsch" herkent iedereen meteen, ook wie de rest van het
   * scherm niet kan lezen. Scheelt bovendien vijftien vertalingen van een
   * talenlijst.
   */
  eigenNaam: string;
  flag: string;
}

export const SUPPORTED_LANGUAGES: readonly Language[] = [
  { code: 'nl-NL', name: 'Dutch', label: 'Nederlands', flag: '🇳🇱', eigenNaam: 'Nederlands' },
  { code: 'hu-HU', name: 'Hungarian', label: 'Hongaars', flag: '🇭🇺', eigenNaam: 'Magyar' },
  { code: 'en-GB', name: 'English', label: 'Engels', flag: '🇬🇧', eigenNaam: 'English' },
  { code: 'de-DE', name: 'German', label: 'Duits', flag: '🇩🇪', eigenNaam: 'Deutsch' },
  { code: 'fr-FR', name: 'French', label: 'Frans', flag: '🇫🇷', eigenNaam: 'Français' },
  { code: 'es-ES', name: 'Spanish', label: 'Spaans', flag: '🇪🇸', eigenNaam: 'Español' },
  { code: 'it-IT', name: 'Italian', label: 'Italiaans', flag: '🇮🇹', eigenNaam: 'Italiano' },
  { code: 'pt-PT', name: 'Portuguese', label: 'Portugees', flag: '🇵🇹', eigenNaam: 'Português' },
  { code: 'pl-PL', name: 'Polish', label: 'Pools', flag: '🇵🇱', eigenNaam: 'Polski' },
  { code: 'tr-TR', name: 'Turkish', label: 'Turks', flag: '🇹🇷', eigenNaam: 'Türkçe' },
  { code: 'ar-SA', name: 'Arabic', label: 'Arabisch', flag: '🇸🇦', eigenNaam: 'العربية' },
  { code: 'ru-RU', name: 'Russian', label: 'Russisch', flag: '🇷🇺', eigenNaam: 'Русский' },
  { code: 'uk-UA', name: 'Ukrainian', label: 'Oekraïens', flag: '🇺🇦', eigenNaam: 'Українська' },
  { code: 'zh-CN', name: 'Chinese', label: 'Chinees', flag: '🇨🇳', eigenNaam: '中文' },
  { code: 'ja-JP', name: 'Japanese', label: 'Japans', flag: '🇯🇵', eigenNaam: '日本語' },
  { code: 'ko-KR', name: 'Korean', label: 'Koreaans', flag: '🇰🇷', eigenNaam: '한국어' },
] as const;

export function findLanguage(code: string): Language | undefined {
  return SUPPORTED_LANGUAGES.find((l) => l.code === code);
}

/** Engelse naam voor het vertaalmodel. Valt terug op de code zelf. */
export function languageName(code: string): string {
  return findLanguage(code)?.name ?? code;
}

export function isSupportedLanguage(code: string): boolean {
  return findLanguage(code) !== undefined;
}
